import { SiteUrls } from '@tableau/shared-urls';
import React from 'react';
import { Route } from 'react-router';
import { defaultMemoize } from 'reselect';
import { BreadcrumbStateInfo, SiteUrlsContext } from '../../../data-catalog-shared';
import { createCatalogBreadcrumb, createCatalogDatabaseBreadcrumb, createCatalogTableBreadcrumb } from './BreadcrumbFactories';
import { BreadcrumbsUpdater } from './BreadcrumbsUpdater';

function createTableBreadcrumbsList(
  tableId: string,
  tableName: string | null,
  databaseId: string | null,
  databaseName: string | null,
  urls: SiteUrls,
  urlSuffix: string,
): ReadonlyArray<BreadcrumbStateInfo> {
  const breadcrumbs = [createCatalogBreadcrumb(urls)];
  if (databaseId !== null && databaseName !== null) {
    breadcrumbs.push(createCatalogDatabaseBreadcrumb(databaseId, databaseName, urls));
  }
  if (tableId !== null && tableName !== null) {
    breadcrumbs.push(createCatalogTableBreadcrumb(tableId, tableName, urls, urlSuffix));
  }

  return breadcrumbs;
}

export type TableBreadcrumbsUpdaterProps = {
  readonly tableId: string;
  readonly tableName: string | null;
  readonly databaseId: string | null;
  readonly databaseName: string | null;
};

export class TableBreadcrumbsUpdater extends React.Component<TableBreadcrumbsUpdaterProps> {

  private readonly memoizedCreateTableBreadcrumbsList = defaultMemoize(createTableBreadcrumbsList);

  public override render() {
    if (this.props.tableName === null) {
      return null;
    }

    return (
      <SiteUrlsContext.Consumer>
        {urls =>
          <Route>
            {({ location }) => {
              const breadcrumbs = this.memoizedCreateTableBreadcrumbsList(
                this.props.tableId,
                this.props.tableName,
                this.props.databaseId,
                this.props.databaseName,
                urls,
                location.search
              );
              return (
                <BreadcrumbsUpdater breadcrumbs={breadcrumbs} />
              );
            }}
          </Route>
        }
      </SiteUrlsContext.Consumer>
    );
  }

}
